import React, { useCallback, useRef, useEffect } from 'react';
import { ATMContainer, ATMGrid } from 'shared-it-appmod-ui';
import { useFireFightingDispatchContext } from 'src/contexts/fire-fighting-dispatch.context';
import history from 'src/history';
import { ToastSuccess } from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import NewDispatchFormHeader from '../fire-dispatch-form/new-dispatch-header/new-dispatch-header.component';
import NewDispatchActionButtons from '../fire-dispatch-form/action-buttons/action-buttons.component';
import FireDispatchAddForm from '../fire-dispatch-form/new-dispatch-form.component';

const FireDispatchAdd: React.FC = () => {
  const { state, actions } = useFireFightingDispatchContext();
  const formRef = useRef<HTMLFormElement>(null);
  const shouldReturn = useRef<boolean>(false);

  useEffect(() => {
    if (!state.helicopterCompanyList.length) {
      actions.getHelicopterCompanyData();
    }
    if (!state.fireAgency.length) {
      actions.getFireAgencyData();
    }
  }, [actions]);

  const handleSave = useCallback(
    (close) => {
      shouldReturn.current = close;
      if (formRef && formRef.current) {
        formRef.current.handleSubmit();
      }
    },
    [formRef, shouldReturn]
  );

  const handleSubmit = useCallback(
    async (data) => {
      const result = await actions.createFireDispatchPOST(data);

      if (result.payload) {
        ToastSuccess(Lang.MSG_FIRE_DISPATCH_CREATE_SUCCESS);

        if (shouldReturn.current) {
          actions.setDefaultData();
          history.push('/dispatch');
        } else {
          history.push(
            `/dispatch/${result.payload.fireDispatch.dispatchId}/edit`
          );
        }
      }
    },
    [shouldReturn, actions]
  );

  return (
    <ATMContainer>
      <NewDispatchFormHeader handleSave={handleSave} />
      <FireDispatchAddForm formRef={formRef} handleSubmit={handleSubmit} />
      <ATMGrid columns={1} style={{ marginTop: '2rem' }}>
        <ATMGrid.Column textAlign="center" verticalAlign="top">
          <NewDispatchActionButtons handleSave={handleSave} />
        </ATMGrid.Column>
      </ATMGrid>
    </ATMContainer>
  );
};

export default FireDispatchAdd;
